import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Body, Footer, Popup } from '@calendly/ui/components/popup'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { etEditorOverlayZIndex } from 'shared/modal_stacking'

import { MembershipsPicker } from './memberships_picker'
import {
  selectedMembershipIdsSelector,
  selectedInvitationIdsSelector,
  initializingSelector,
  selectedUserGroupIdsSelector,
  orgAdminsToRemoveSelector,
  selectedMigrationsSelector
} from './selectors'

export const MembershipsPickerModal = ({
  isOpen,
  title,
  eyebrowLabel = null,
  subtitle = null,
  description = null,
  submitButtonText = null,
  isSubmitting = false,
  onSubmit,
  onClose,
  ...props
}) => {
  const initializing = useSelector(initializingSelector)
  const organizationMembershipIds = useSelector(selectedMembershipIdsSelector)
  const organizationMigrationIds = useSelector(selectedMigrationsSelector)
  const organizationInvitationIds = useSelector(selectedInvitationIdsSelector)
  const orgAdminsToRemove = useSelector(orgAdminsToRemoveSelector)
  const userGroupIds = useSelector(selectedUserGroupIdsSelector)

  const handleSubmit = () => {
    onSubmit({ organizationMembershipIds, organizationInvitationIds, userGroupIds, orgAdminsToRemove, organizationMigrationIds })
  }
  if (!isOpen) return null

  return (
    <Popup isOpen={isOpen} onClose={onClose} size="medium" zIndex={etEditorOverlayZIndex}>
      <Header title={title} eyebrowLabel={eyebrowLabel} subtitle={subtitle} />
      <Body>
        {description && <div>{description}</div>}
        <MembershipsPicker {...props} />
      </Body>
      <Footer isOffset>
        <Button onClick={onClose} decoration="ghost">
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button loading={isSubmitting} disabled={initializing} onClick={handleSubmit}>
          {submitButtonText || I18n.t('publisher.action.add')}
        </Button>
      </Footer>
    </Popup>
  )
}

MembershipsPickerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  inputPlaceholder: PropTypes.string,
  submitButtonText: PropTypes.string,
  notFoundPlaceholderTitle: PropTypes.string,
  notFoundPlaceholderText: PropTypes.node,
  getUnavailabilityReason: PropTypes.func,
  isSubmitting: PropTypes.bool,
  initialValue: PropTypes.shape({
    organizationMembershipIds: PropTypes.arrayOf(PropTypes.number),
    organizationInvitationIds: PropTypes.arrayOf(PropTypes.number),
    userGroupIds: PropTypes.arrayOf(PropTypes.number),
    organizationMigrationIds: PropTypes.arrayOf(PropTypes.number),
  }),
  entities: PropTypes.arrayOf(PropTypes.oneOf(['memberships', 'invitations', 'userGroups', 'migrations'])),
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedSuggestionsComponent: PropTypes.elementType,
  eyebrowLabel: PropTypes.string,
  subtitle: PropTypes.string,
  userGroupIds: PropTypes.arrayOf(PropTypes.number)
}
